<template>
  <div class="main-box main-content">
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="650px" :close-on-click-modal="false">
      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <el-row :gutter="15">
          <el-col :span="24">
            <el-form-item  label="公卫账户" prop="phLoginName">
              <el-input v-model="temp.phLoginName" style="width: 300px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="公卫密码" prop="phLoginPassword">
              <el-input v-model="temp.phLoginPassword" style="width: 300px"></el-input>
              <xr-button type="primary" @click="checkPhPassword">验证密码，成功后更新公卫信息</xr-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="验证状态" prop="phLoginPassword">
              <a style="color: green;" v-if="checkStatus == '1'">验证成功</a>
              <a style="color: green;" v-if="checkStatus == 'success'">验证成功，且保存公卫数据成功！</a>
              <a style="color: red;" v-if="checkStatus == 'error'">验证失败</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <xr-button type="default" @click="dialogVisible =false">关闭</xr-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

    export default {
        name: "partyBSelect",
        data() {
          return {
            dialogName: '设置公卫账户密码并更新用户信息',
            dialogVisible: false,                                       //弹框
            type: 'save',                                                //类型
            checkStatus: '',                                            //验证状态
            temp:{
            	id :'',
              phLoginName: '',
              phLoginPassword: ''
            },
            rules: {
              phLoginName: [
                { message: '公卫账户不能为空!', required: true, trigger: 'blur' }
              ],
              phLoginPassword: [
                { message: '公卫密码不能为空!', required: true, trigger: 'blur' }
              ],
            }
          }
        },
        components: {

        },
        methods: {
          init(id){
            this.dialogVisible = true;
            this.temp.id = id;
            return this.request({
              method:'post',
              url:'/web/service',
              params:{
                'method': 'tCoreUser_getPageInfo',
                'id': id,
                'type': 'view'
              }
            }).then((response) =>{          //这里使用了ES6的语法
              // 请求成功返回的数据
              //如果返回编码不为0，提示失败语
              if(response.code != '0'){
                this.$message.error(response.msg);
                return false;
              }

              if(!!response.data && !!response.data.info  && !!response.data.info.phLoginName){
                this.temp.phLoginName = response.data.info.phLoginName;
                this.checkStatus= response.data.info.phCheckStatus
              }

            })
          },
          //验证密码
          checkPhPassword(){
            return this.request({
              method:'post',
              url:'/web/service?method=tCoreUser_checkPhPassword',
              params: {
                id: this.temp.id,
                phLoginName: this.temp.phLoginName,
                phLoginPassword: this.temp.phLoginPassword
              }
            }).then((response) =>{
              if (response.code === 0) {
                this.$message({message: '验证成功', type: 'success', duration: 1500})
                this.checkStatus = 'success';
                this.$emit('refreshUserInfo')
              } else {
                this.$message.error(response.msg)
                this.checkStatus = 'error';
              }
            })
          },
          //重置
          resetTemp() {
            this.temp.phLoginName = '';
            this.temp.phLoginPassword = '';
            this.checkStatus = '';
            this.$nextTick(() => {      //清空校验
              this.$refs['dataForm'].clearValidate()
            })
          },
          //关闭
          close(){
            this.dialogVisible = false
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/user-edit-ph-password.vue